export type LocationOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

export const countryOptions: LocationOption[] =
  (window as any)?.sfdcBase?.countryOptions || [];
export const stateOptions: Record<string, LocationOption[]> =
  (window as any)?.sfdcBase?.stateOptions || {};

// Convenience method to get country label given the country value
export const getCountryLabel = (
  countryValue: string | null | undefined
): string | null => {
  if (!countryValue) {
    return null;
  }

  const country = countryOptions.find((c) => c.value === countryValue);
  return country?.label || countryValue; // If we couldn't find the label, return the value instead
};
// Convenience method to get state label given the country and states values
export const getStateLabel = (
  countryValue: string | null | undefined,
  stateValue?: string | null | undefined
) => {
  if (!countryValue || !stateValue) {
    return null;
  }

  const state = stateOptions[countryValue]?.find((s) => s.value === stateValue);
  return state?.label || stateValue;
};
